/* src/app/components/game-layer/session-component/session-component.css */
.sessions-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 4px 0 22px;
}
.sessions-header-row .empty-copy {
  margin: 0;
}
.session-panel {
  margin-bottom: 24px;
  padding: 22px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--line);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.1),
      transparent 26%),
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.88) 0%,
      rgba(30, 23, 19, 0.96) 100%);
  box-shadow: var(--shadow);
}
@media (max-width: 640px) {
  .sessions-header-row {
    flex-direction: column;
  }
  .sessions-header-row .primary-btn {
    width: 100%;
  }
}
.session-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin-top: 18px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group span {
  color: #f3e7c0;
  font-weight: 600;
}
.session-description {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.session-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  color: var(--ink);
}
.session-campaign-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: 16px;
  padding: 18px;
  border-radius: var(--radius-md);
  border: 1px solid rgba(240, 215, 122, 0.14);
  color: var(--ink);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.08),
      transparent 30%),
    rgba(255, 255, 255, 0.04);
  text-decoration: none;
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;
}
.session-campaign-link:hover {
  color: var(--ink);
  border-color: rgba(212, 175, 55, 0.34);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.12),
      transparent 30%),
    rgba(255, 255, 255, 0.06);
  text-decoration: none;
  transform: translateY(-1px);
}
.session-campaign-content {
  display: grid;
  gap: 8px;
  min-width: 0;
}
.session-campaign-kicker {
  color: var(--gold);
  font-size: 0.76rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.session-campaign-title {
  color: #fbf4df;
  font-size: 1.08rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.session-campaign-description {
  display: block;
  overflow: hidden;
  color: var(--ink-soft);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.session-campaign-universe {
  color: var(--gold-bright);
  font-weight: 600;
  overflow-wrap: anywhere;
}
.session-campaign-action {
  flex: 0 0 auto;
  color: var(--gold-bright);
  font-size: 1.2rem;
}
.session-link {
  color: var(--gold-bright);
  text-decoration: none;
}
.session-link:hover {
  color: #fff4d1;
  text-decoration: underline;
}
.session-action-row {
  margin-top: 16px;
}
.session-player-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 18px;
}
.session-player-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-radius: var(--radius-md);
  border: 1px solid rgba(240, 215, 122, 0.12);
  background: rgba(255, 255, 255, 0.04);
}
.session-player-row span {
  overflow-wrap: anywhere;
}
.session-state {
  display: inline-flex;
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid var(--line);
  font-size: 0.92rem;
}
.joined-state {
  color: #f3e7c0;
  background: rgba(112, 154, 118, 0.12);
  border-color: rgba(112, 154, 118, 0.22);
}
.full-state {
  color: #ffe6dc;
  background: rgba(143, 47, 47, 0.18);
  border-color: rgba(255, 192, 169, 0.18);
  margin: 10px;
}
.button-row {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}
.validation-text {
  color: #ffb8a2;
}
.join-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(8, 6, 6, 0.78);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
.join-modal {
  width: min(560px, 100%);
  padding: 24px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--line);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.14),
      transparent 28%),
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.96) 0%,
      rgba(30, 23, 19, 0.98) 100%);
  box-shadow: var(--shadow);
}
@media (max-width: 640px) {
  .session-campaign-link {
    margin-top: 14px;
    padding: 12px 0;
    border-width: 1px 0;
    border-radius: 0;
    background: transparent;
  }
  .session-campaign-link:hover {
    background: transparent;
  }
  .session-campaign-description {
    display: none;
  }
  .session-player-row {
    align-items: stretch;
    flex-direction: column;
  }
}
/*# sourceMappingURL=session-component.css.map */
